import { Col, Descriptions, Row, Button, Typography } from "antd";
import dayjs from "dayjs";
import { isEmpty, isNull, isUndefined } from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import { dateFormat } from "../shared/formatting";

const RenewalSummary = ({ selected }) => {
  const maskSensitiveData =
    useSelector((state) => state.actor?.details?.data?.MaskSensitiveData) &&
    !isNew;

  const handleDocumentOpen = (documentKey) => {
    window.open(
      `${process.env.REACT_APP_BASENAME}documents/updatedocumentform/${documentKey}`,
      `${documentKey}`
    );
  };

  return (
    <Row>
      <Col span={24}>
        {selected && (
          <>
            <Descriptions size="small" column={3}>
              {/* Column 1 */}
              <Descriptions.Item label="Policy Number">
                <Typography.Link
                  onClick={() => handleDocumentOpen(selected.DocumentKey)}
                >
                  {selected.PolicyNumber}
                </Typography.Link>
              </Descriptions.Item>
              <Descriptions.Item label="Agency">
                {selected.AgencyNumberAndName}
              </Descriptions.Item>
              <Descriptions.Item label="Assigned To">
                {selected.AssignedTo}
              </Descriptions.Item>

              <Descriptions.Item label="Plate Number">
                <Typography.Link
                  onClick={() => handleDocumentOpen(selected.DocumentKey)}
                >
                  {selected.PlateNumber}
                </Typography.Link>
              </Descriptions.Item>
              <Descriptions.Item label="Policy Type">
                {selected.PolicyType}
              </Descriptions.Item>
              <Descriptions.Item label="Reminder Status">
                {selected.RequestStatusDesc}
              </Descriptions.Item>

              <Descriptions.Item label="Customer">
                <div
                  className={maskSensitiveData === true ? "blurry-text" : ""}
                >
                  {selected.InsuredName}
                </div>
              </Descriptions.Item>
              <Descriptions.Item label="Policy Status">
                {selected.PolicyStatusDesc}
              </Descriptions.Item>
              <Descriptions.Item label="Processing Stage">
                {selected.LatestProcessingStageDesc}
              </Descriptions.Item>

              <Descriptions.Item label="Phone">
                {selected.CustomerHomePhone}
              </Descriptions.Item>
              <Descriptions.Item label="Expiry">
                {selected.PolicyExpiryDate
                  ? dayjs(selected.PolicyExpiryDate).format(dateFormat[0])
                  : "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Updated Date">
                {selected.UpdatedDate
                  ? dayjs(selected.UpdatedDate).format(dateFormat[0])
                  : "N/A"}
              </Descriptions.Item>

              <Descriptions.Item label="Email">
                {selected.Email}
              </Descriptions.Item>

              <Descriptions.Item label="Policy Status Change Date">
                {selected.PolicyStatusChangeDate
                  ? dayjs(selected.PolicyStatusChangeDate).format(dateFormat[0])
                  : "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Producer Code 1">
                {`${selected.ProducerCode1} - ${selected.ProducerName1}`}
              </Descriptions.Item>

              <Descriptions.Item label="Vehicle">
                {selected.VehicleDescription}
              </Descriptions.Item>

              <Descriptions.Item label="Policy Status Change Agency">
                {selected.PolicyStatusChangeAgency}
              </Descriptions.Item>
              <Descriptions.Item label="Producer Code 2">
                {`${selected.ProducerCode2} - ${selected.ProducerName2}`}
              </Descriptions.Item>
            </Descriptions>
          </>
        )}
      </Col>
    </Row>
  );
};

export default RenewalSummary;
